import {createContext, useContext} from "react"
import {UseBoundStore, StoreApi} from "zustand"
import {GuidedTourState} from "../root.component"

type AppContextType = {
  useGuidedTourStore: UseBoundStore<StoreApi<GuidedTourState>>
}

export const AppContext = createContext<AppContextType | null>(null)

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider")
  }

  return context
}
